// extracted by mini-css-extract-plugin
module.exports = {"sheet-content":"_652","check-item":"_10885","check-item-txt":"_4322","phone":"_2960","textarea":"_4312","form":"_4681","sheet-bottom":"_16409","addbtn":"_11136"};